import {useTheme, css, Typography} from '@mui/material';
import {
  DlMuiPopper,
  GetStylesFunction,
  useMuiAnchor,
  mixins,
} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import * as React from 'react';
import {useIntl} from 'react-intl';

import baseDateFormatterParams from 'src/js/lib/raw_rendering/base_date_formatter_params';

interface OwnProps {
  dateOnly?: boolean;
}

type Props = ICellRendererParams & OwnProps;

export const DateFormatter: React.FC<Props> = (props) => {
  const intl = useIntl();
  const {formattedValue, value} = baseDateFormatterParams(props, {
    intl,
  });

  const hasTooltip = !!value;

  const {mouseEventEnter, mouseEventLeave, open, anchorEl} =
    useMuiAnchor(hasTooltip);
  const theme = useTheme();
  const styles = getStyles({theme});

  return value ? (
    <Typography variant={'value'}>
      <span
        css={styles.span}
        onMouseEnter={mouseEventEnter}
        onMouseLeave={mouseEventLeave}
      >
        {formattedValue}
      </span>
      <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
        <Typography variant={'popper'}>{formattedValue}</Typography>
      </DlMuiPopper>
    </Typography>
  ) : (
    <>{'-'}</>
  );
};

DateFormatter.displayName = 'DateFormatter';

const getStyles: GetStylesFunction = (options) => ({
  span: css`
    ${mixins?.dlTextOverflowEllipses};
    padding: ${options?.theme?.spacing(1, 0)};
  `,
});
